import TemplateProvider, {
  TemplateContext,
  useTemplateContext,
} from "./TemplateProvider";

export { TemplateContext, TemplateProvider, useTemplateContext };
